import { InfoOutlined } from "@mui/icons-material";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';

export const MeetingOkrsTooltip = () => {
  const { t } = useTranslation();
  return (
    <Tooltip
      placement="bottom"
      title={
        <Typography component={'span'} sx={{ fontSize: '12px', color: 'white' }}>
          {t('OKRs displayed here are OKRs that both parties have permission to access')}
        </Typography>
      }
    >
      <IconButton
        aria-label={t('Information about OKRs')}
        sx={{ ml: 'auto', padding: 0, marginLeft: '6px', marginTop: '-3px', width: '12px', height: '12px' }}
      >
        <InfoOutlined sx={{ width: '18px' }} />
      </IconButton>
    </Tooltip>
  );
};
